import { Endpoint } from './api/types'

type SiginonRequest = Endpoint & {
  heartlinePk: number
  accessToken: string
}

export const signonUrl = ({
  endpoint,
  heartlinePk,
  accessToken
}: SiginonRequest) => {
  const url = new URL(endpoint)
  return `${url.protocol}//${url.host}/login/heartline/?heartline_pk=${heartlinePk}&access_token=${accessToken}`
}
